import React, { SyntheticEvent, useState } from "react";
import FormContainer from "../components/FormContainer";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { LoginAuth } from '../Services/LoginService'
import { useNavigate } from 'react-router-dom';
import { LoginResponse } from "../instances/Instances";
import { useGlobalContext } from '../context/store'
import NavigationBar from "../components/NavigationBar";


const LoginPage = () => {

    const { setToken } = useGlobalContext()

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState('');
    const navigate = useNavigate();

    //Login button validation
    const validateForm = () => {
        return email.length > 0 && password.length > 0;
    }

    const handleSubmit = async (e: SyntheticEvent) => {
        e.preventDefault();
        //interact with backend
        const authorized: LoginResponse = await LoginAuth(email, password);

        //If token is provided
        if (authorized.Token != null) {
            //save Current user to sessionStorage
            sessionStorage.setItem('CurrentUser', JSON.stringify(authorized.User));
            setToken(authorized.Token)

            //navigate to main page
            navigate('./main');
        } else {
            //provide error message
            setError('Invalid Email or Password')
            setTimeout(() => {
                setError('')
            }, 3000);
        }
    }

    return (

        <>
            <NavigationBar toggleNav={false} />
            <FormContainer>
                <h1>Login</h1>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="email" className='my-3'>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            autoFocus
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="password" className='my-3'>
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Form.Group>

                    <Button size="lg" type="submit" className='my-3' disabled={!validateForm()}>
                        Login
                    </Button>
                    <p className='text-danger mt-3'>{error}</p>
                </Form>

            </FormContainer>
        </>

    )
}

export default LoginPage
